import * as actions from '../redux/constants';
import * as gatewayService from '../core/gateway';

export const gatewaySyncGradesJobInit = (courseId) => async (dispatch) => {
  try {
    dispatch({
      type: actions.APP_LOADING,
      payload: true,
    });

    const syncGradesData = await gatewayService.syncGrades(courseId);
    const returnObj = {
      id: syncGradesData.jobId,
      message: null,
      status:
        syncGradesData.jobId && syncGradesData.status === 'success'
          ? 'pending'
          : syncGradesData.status,
      statusMessage: syncGradesData.statusMessage,
      results: null,
    };
    return returnObj;
  } catch (e) {
    dispatch({
      type: actions.APP_ERROR,
      payload: e,
    });
    throw e;
  } finally {
    dispatch({
      type: actions.APP_LOADING,
      payload: false,
    });
  }
};

export const gatewaySyncGradesJobUpdate = (jobId) => async (dispatch) => {
  try {
    dispatch({
      type: actions.APP_LOADING,
      payload: true,
    });

    const syncGradesData = await gatewayService.jobStatus(jobId);
    const returnObj = { ...syncGradesData };

    if (syncGradesData) {
      switch (syncGradesData.job_status_code) {
        case 2:
          returnObj.status = 'running';
          break;
        case 3:
          returnObj.status = 'error';
          break;
        case 4:
          returnObj.status = 'complete';
          returnObj.results = syncGradesData.results;
          break;
        case 1:
        default:
          returnObj.status = 'pending';
          break;
      }
      returnObj.message = syncGradesData.message;
      returnObj.statusMessage = syncGradesData.job_status_message;
    }
    return returnObj;
  } catch (e) {
    dispatch({
      type: actions.APP_ERROR,
      payload: e,
    });
    throw e;
  } finally {
    dispatch({
      type: actions.APP_LOADING,
      payload: false,
    });
  }
};
